import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import Button from 'antd/lib/button';
import Message from 'antd/lib/message';

import {TypeKeys} from '@common/react/store/VideoChat';

import {ApplicationState} from '@app/store';
import {request} from '@app/components/Api';

interface VideoChatButtonProps {
	roomId: string;
	roomName: string;
	roomCreateActor: string;
	avatar?: string;
	chatId?: number;
	button?: (onClick: React.MouseEventHandler, isDisabled: boolean) => JSX.Element;
	support?: boolean;
	onClick?: () => void;
	notifyUserIds?: number[];
}

const VideoChatButton: React.FC<VideoChatButtonProps> = (props) => {
	const {button, support, roomId, roomName, notifyUserIds, roomCreateActor, chatId, onClick, avatar} = props;
	const dispatch = useDispatch();
	const isChatting = useSelector((state: any) => state.videoChat.isChatting);
	
	const handleClick: React.MouseEventHandler = (e) => {
		e.preventDefault();
		
		const handleSuccess = (res) => {
			dispatch({
				type: TypeKeys.UPDATE, 
				data: {
					token: res.token, 
					roomIdentifier: res.roomIdentifier, 
					roomName: roomName,
					avatar,
					isSupport: support ?? false,
					hasError: false
				}
			});
		};
		
		request<{token: string, roomIdentifier: string}>(roomCreateActor, {roomName: roomId, chatId, notifyUserIds})
			.then(handleSuccess)
			.catch((e) => {
				Message.error(e);
				dispatch({type: TypeKeys.UPDATE, data: {hasError: true}});
			});

		dispatch({
			type: TypeKeys.UPDATE,
			data: {
				visibility: true,
				isChatting: true,
				roomName: roomName,
				avatar,
				isSupport: support ?? false,
				hasError: false
			}});
		onClick && onClick();
	};
	
	return button ? 
		button(handleClick, isChatting) : 
		<Button
			htmlType="button"
			shape="circle"
			onClick={handleClick}
			disabled={isChatting}
		>
			<i className="fa fa-video-camera"/>
		</Button>;
};

export default VideoChatButton;